import { useState, useEffect } from 'react';
import { Sun, Moon } from 'lucide-react';

export function ThemeToggle() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof document === 'undefined') return false;
    return document.documentElement.classList.contains('dark');
  });

  useEffect(() => {
    const syncTheme = () => {
      setIsDark(document.documentElement.classList.contains('dark'));
    };
    syncTheme();
    window.addEventListener('tsos_theme_changed', syncTheme);
    window.addEventListener('storage', syncTheme);
    return () => {
      window.removeEventListener('tsos_theme_changed', syncTheme);
      window.removeEventListener('storage', syncTheme);
    };
  }, []);

  const toggleTheme = () => {
    const nextDark = !isDark;
    setIsDark(nextDark);
    if (nextDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('tsos_theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('tsos_theme', 'light');
    }
    window.dispatchEvent(new CustomEvent('tsos_theme_changed', { detail: { isDark: nextDark } }));
  };

  return (
    <button
      onClick={toggleTheme}
      className="p-2 text-brand-muted hover:text-brand-ink transition-colors rounded-lg min-h-[44px] min-w-[44px] flex items-center justify-center"
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      {isDark ? (
        <Sun className="h-4 w-4 text-amber-400" />
      ) : (
        <Moon className="h-4 w-4 text-brand-muted" />
      )}
    </button>
  );
}

export default ThemeToggle;
